import { render } from "./SoSinhTu.vue?vue&type=template&id=53578e19&scoped=true"
import script from "./SoSinhTu.vue?vue&type=script&lang=js"
export * from "./SoSinhTu.vue?vue&type=script&lang=js"

import "./SoSinhTu.vue?vue&type=style&index=0&id=53578e19&scoped=true&lang=css"

import exportComponent from "/Users/muoitrinh/Documents/Projects/BetmintonApp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53578e19"]])

export default __exports__